import React from 'react';
import proptypes from 'prop-types';
import { GraphQLError } from 'graphql/error/GraphQLError.js';
import { InMemoryCache, disableFragmentWarnings } from '@apollo/client';
import { MockedProvider as ApolloMockedProvider, MockLink } from '@apollo/client/testing/testing.cjs.js';
import { typePolicies, dataIdFromObject } from '../react/util';
import possibleTypes from '../shapes/possibleTypes';
import { createMock, mockRequestResponse } from './createMock';

const { node, bool, shape, arrayOf } = proptypes;
const staticCache = new InMemoryCache({
  typePolicies,
  dataIdFromObject,
  possibleTypes,
  addTypename: false,
});

const MockedProvider = (props) => {

  const defaultCache = new InMemoryCache({
    typePolicies,
    dataIdFromObject,
    possibleTypes,
    addTypename: false,
  });

  // eslint-disable-next-line react/destructuring-assignment
  const cache = props.useStaticCache
    ? staticCache
    : defaultCache;

  disableFragmentWarnings();

  if (typeof window !== 'undefined' && window.__APOLLO_STATE__) {//eslint-disable-line
    cache.restore(window.__APOLLO_STATE__);//eslint-disable-line
  }
  const {
    children, addTypename, cache: paramsCache, mocks, link
  } = props;
  return (
    <ApolloMockedProvider
      // addTypename // do not add this field
      cache={paramsCache || cache}
      addTypename={addTypename}
      mocks={mocks}
      link={link}
    >
      {children}
    </ApolloMockedProvider>
  );
};

MockedProvider.propTypes = {
  children: node.isRequired,
  addTypename: bool,
  cache: shape({}),
  mocks: arrayOf(shape({})).isRequired,
  useStaticCache: bool,
  link: shape({})
};
MockedProvider.defaultProps = {
  addTypename: false,
  cache: null,
  useStaticCache: true,
  link: undefined
};

export {
  MockedProvider,
  MockLink,
  createMock,
  mockRequestResponse,
  GraphQLError
};
